module.exports = __webpack_public_path__ + "img/wmdys.b0cc0bbd.svg";